import useSWR from 'swr'

const fetcher = (...args: Parameters<typeof fetch>) =>
  fetch(...args).then((res) => res.json())

export const useProductViews = ({ sku }: { sku?: string }) => {
  const shouldFetch = sku && sku.trim().length > 0
  const { data, error, isLoading } = useSWR<{
    productView: number | null
  }>(
    shouldFetch
      ? `/api/get-product-views?sku=${encodeURIComponent(sku)}`
      : null,
    fetcher,
  )

  const formattedProductViewCount = data?.productView

  return {
    productViews: formattedProductViewCount,
    isLoading,
    isError: error,
  }
}
